import createIcon from '../../createIcon';

/**
 * @component @name CalendarToday
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgM0gxOVYxSDE3VjNIN1YxSDVWM0g0QzIuOSAzIDIgMy45IDIgNVYyMUMyIDIyLjEgMi45IDIzIDQgMjNIMjBDMjEuMSAyMyAyMiAyMi4xIDIyIDIxVjVDMjIgMy45IDIxLjEgMyAyMCAzWk0yMCAyMUg0VjhIMjBWMjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CalendarToday = createIcon('CalendarToday', [
  [
    'path',
    {
      d: 'M20 3H19V1H17V3H7V1H5V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM20 21H4V8H20V21Z',
      key: '5tyead',
    },
  ],
]);

export default CalendarToday;
